var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_656_88",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 20,
    height: 20
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_656_88)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 15.0305,
    width: 20,
    height: 7.4074,
    fill: "#DB5F7B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 7.62311,
    width: 20,
    height: 7.4074,
    fill: "#6FB1D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.215759,
    width: 20,
    height: 7.4074,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.84772 4.48279C5.31064 4.5241 5.46213 5.18512 5.39327 5.55694C5.20047 8.13215 4.93882 10.79 5.72378 13.3101C6.34348 15.3345 7.83077 17.0008 9.63479 18.0887C10.0755 18.3366 10.5024 18.6396 10.9981 18.7773C11.5214 18.6258 11.9621 18.3091 12.4303 18.0474C14.2068 16.9732 15.6528 15.3069 16.2725 13.3101C17.0712 10.7624 16.7958 8.04953 16.5892 5.433C16.5479 5.07495 16.603 4.44148 16.0659 4.48279H5.84772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1351 4.88214H10.9847H5.84806C5.43492 10.3493 4.76013 15.3482 10.9847 18.3641C17.2231 15.3482 16.5345 10.3493 16.1351 4.88214Z",
    fill: "#DB5F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2482 9.66075C13.601 9.78469 12.94 9.89486 12.279 9.89486H11.5629V8.5866H11.7281C12.3754 8.5866 13.0501 8.71054 13.6974 8.83448C13.5046 8.21478 13.5046 7.82918 13.6974 7.19571C13.0364 7.33342 12.3754 7.44359 11.7143 7.44359H11.5629V7.36096C11.5629 6.71372 11.6868 6.03893 11.8107 5.40546C11.1773 5.59825 10.7917 5.59825 10.172 5.40546C10.2959 6.03893 10.4199 6.71372 10.4199 7.36096V7.44359H10.2546C9.60735 7.44359 8.93257 7.31965 8.28532 7.19571C8.47812 7.81541 8.47812 8.20101 8.28532 8.83448C8.93257 8.71054 9.59358 8.5866 10.2546 8.5866H10.4199V9.90863H9.68998C9.02896 9.90863 8.36795 9.78469 7.7207 9.66075C7.89973 10.2805 7.89973 10.666 7.7207 11.2995C8.35418 11.1756 9.02896 11.0516 9.68998 11.0516H10.4199V15.7201H11.5629V11.0379H12.2927C12.9538 11.0379 13.6148 11.1618 14.262 11.2857C14.0554 10.666 14.0554 10.2805 14.2482 9.66075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9234 15.0178C14.9234 14.2879 14.3175 13.6957 13.5876 13.6957C13.1882 13.682 12.844 13.861 12.5961 14.1226C12.3895 13.4203 11.756 12.8832 10.9848 12.8832C10.2137 12.897 9.59396 13.4203 9.37362 14.1226C9.13951 13.861 8.79523 13.682 8.39586 13.682C7.66599 13.682 7.06006 14.2741 7.06006 15.004C7.06006 15.0591 7.06006 15.1142 7.07383 15.1693C7.14269 15.2657 7.23908 15.3621 7.30794 15.4584H7.2804C8.10667 16.5464 9.27722 17.5379 10.9848 18.3642C12.6925 17.5379 13.863 16.5601 14.6893 15.4722H14.6617C14.7306 15.3758 14.827 15.2794 14.8959 15.1693C14.9096 15.1279 14.9234 15.0729 14.9234 15.0178Z",
    fill: "#6FB1D6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSk);
export default __webpack_public_path__ + "static/media/sk.f80a6319a21fbac3a9496cda01e4b648.svg";
export { ForwardRef as ReactComponent };